import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-644b206a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search_container"
};
const _hoisted_2 = {
  class: "tab_container"
};
const _hoisted_3 = {
  class: "tab_warp"
};
const _hoisted_4 = {
  class: "btn_wrap"
};
const _hoisted_5 = {
  class: "table_container"
};
import ChannelList from '@/views/payManage/appManage/components/ChannelList.vue';
import AppAddOrEditModal from '@/views/payManage/appManage/components/AppAddOrEditModal.vue';
import AppAddAuthModal from '@/views/payManage/appManage/components/AppAddAuthModal.vue';
import { queryAppList } from '@/api/payManage/appManage';
import { OK, reportEvent, isSandboxEnv } from '@/common';
import SearchBlock from './components/SearchBlock.vue';
import AppTableBlock from '@/views/payManage/appManage/components/AppTableBlock.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { useBasicOptions } from './hooks/useBasicOptions';
import { useMarketList } from './hooks/useMarketList';
import { pubStatusList } from './hooks/pubStatus';
import { subscriptionStatusData } from './hooks/includeSubscriptionStatus';
import { payChannelList } from './hooks/payChannelList';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      studioList,
      accountList,
      companyList
    } = useBasicOptions();
    const {
      marketList,
      MarketTypeEnum
    } = useMarketList();
    const curMarket = ref(MarketTypeEnum.ALL);
    const querySearch = ref({});
    const pageNum = ref(1);
    const pageSize = ref(20);
    const pageTotal = ref(0);
    const dataSource = ref([]);
    const appTableBlockRef = ref();
    const searchBlockRef = ref();
    const dataItem = ref({});
    const editVisible = ref(false);
    const addAuthVisible = ref(false);
    const channelVisible = ref(false);
    const productItem = ref({
      dbtId: ''
    });
    const choosedChannel = ref('');
    const routeName = computed(() => {
      return useRoute().name;
    });
    const changeFilter = options => {
      querySearch.value = {
        ...options
      };
      onSearch();
    };
    const handleEdit = item => {
      dataItem.value = item;
      editVisible.value = true;
    };
    const handleAddAuth = () => {
      addAuthVisible.value = true;
    };
    const showChannelEdit = (item, record) => {
      choosedChannel.value = item;
      productItem.value = {
        ...record
      };
      channelVisible.value = true;
    };
    const changeMarket = () => {
      initList();
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '产品管理',
          element_name: '切换市场类型'
        }
      });
    };
    const onSearch = async () => {
      pageNum.value = 1;
      const startTime = new Date().getTime();
      const status = await queryList();
      const duartion = new Date().getTime() - startTime;
      const extraInfo = {
        query_status: status,
        return_duration: duartion * 1,
        element_name: '产品管理-筛选'
      };
      reportEvent({
        eventName: '_search',
        properties: extraInfo
      });
    };
    const changePage = async (page, pageS) => {
      pageNum.value = page;
      pageSize.value = pageS;
      queryList();
    };
    const getParams = () => {
      var _marketList$value$fin, _marketList$value;
      const params = {
        ...querySearch.value,
        publishPlatforms: [],
        pageNum: pageNum.value,
        pageSize: pageSize.value
      };
      params.publishPlatforms = (_marketList$value$fin = (_marketList$value = marketList.value) === null || _marketList$value === void 0 || (_marketList$value = _marketList$value.find(item => item.value === curMarket.value)) === null || _marketList$value === void 0 ? void 0 : _marketList$value.publishPlatforms) !== null && _marketList$value$fin !== void 0 ? _marketList$value$fin : [];
      return params;
    };
    const queryList = async () => {
      const params = getParams();
      try {
        const {
          data: {
            list,
            total
          },
          code
        } = await queryAppList(params);
        if (code === OK) {
          var _list$map;
          pageTotal.value = total;
          dataSource.value = (_list$map = list === null || list === void 0 ? void 0 : list.map(item => {
            return {
              ...item
            };
          })) !== null && _list$map !== void 0 ? _list$map : [];
        }
        return code === OK ? 'succeed' : 'failed';
      } catch (e) {
        return 'failed';
      }
    };
    const initList = () => {
      pageNum.value = 1;
      queryList();
    };
    // 产品新建/编辑成功后：刷新列表，同时刷新本页筛选区的产品下拉
    const handleAppSaved = () => {
      var _searchBlockRef$value;
      queryList();
      (_searchBlockRef$value = searchBlockRef.value) === null || _searchBlockRef$value === void 0 || _searchBlockRef$value.getDbtProducts();
    };
    watch(() => marketList.value, newVal => {
      if (newVal !== null && newVal !== void 0 && newVal.length) {
        var _newVal$;
        curMarket.value = newVal === null || newVal === void 0 || (_newVal$ = newVal[0]) === null || _newVal$ === void 0 ? void 0 : _newVal$.value;
        initList();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(SearchBlock, {
        ref_key: "searchBlockRef",
        ref: searchBlockRef,
        studioList: _unref(studioList),
        accountList: _unref(accountList),
        companyList: _unref(companyList),
        pubStatusList: _unref(pubStatusList),
        subscriptionStatusData: _unref(subscriptionStatusData),
        payChannelList: _unref(payChannelList),
        choosedMarket: curMarket.value,
        onSearch: changeFilter
      }, null, 8, ["studioList", "accountList", "companyList", "pubStatusList", "subscriptionStatusData", "payChannelList", "choosedMarket"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_tabs, {
        activeKey: curMarket.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => curMarket.value = $event),
        onChange: changeMarket
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(marketList), item => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.value,
            tab: item.label
          }, null, 8, ["tab"]);
        }), 128))]),
        _: 1
      }, 8, ["activeKey"])]), _createElementVNode("div", _hoisted_4, [_unref(isSandboxEnv) ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "add-btn m-r-12",
        onClick: handleAddAuth
      }, {
        icon: _withCtx(() => [_createVNode(SvgIcon, {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 添加产品授权 ")]),
        _: 1
      })) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        class: "add-btn",
        onClick: _cache[1] || (_cache[1] = $event => handleEdit({}))
      }, {
        icon: _withCtx(() => [_createVNode(SvgIcon, {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新建 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: _unref(routeName),
        btnType: 'add'
      }]])])]), _createElementVNode("div", _hoisted_5, [_createVNode(AppTableBlock, {
        ref_key: "appTableBlockRef",
        ref: appTableBlockRef,
        dataSource: dataSource.value,
        onShowChannel: showChannelEdit,
        onRefresh: queryList
      }, null, 8, ["dataSource"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageNum.value,
        "onUpdate:current": _cache[2] || (_cache[2] = $event => pageNum.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"])]), _createVNode(AppAddOrEditModal, {
        "modal-visible": editVisible.value,
        "onUpdate:modal-visible": _cache[4] || (_cache[4] = $event => editVisible.value = $event),
        dataItem: dataItem.value,
        onRefresh: handleAppSaved
      }, null, 8, ["modal-visible", "dataItem"]), _createVNode(AppAddAuthModal, {
        "modal-visible": addAuthVisible.value,
        "onUpdate:modal-visible": _cache[5] || (_cache[5] = $event => addAuthVisible.value = $event),
        onRefresh: queryList
      }, null, 8, ["modal-visible"]), _createVNode(ChannelList, {
        "modal-visible": channelVisible.value,
        "onUpdate:modal-visible": _cache[6] || (_cache[6] = $event => channelVisible.value = $event),
        choosedMarket: curMarket.value,
        choosedChannel: choosedChannel.value,
        productItem: productItem.value,
        onUpdateList: queryList
      }, null, 8, ["modal-visible", "choosedMarket", "choosedChannel", "productItem"])]);
    };
  }
});